import { Flow } from 'signup-constants/Flow';
import { PartnerType } from './PartnerType';
export const FlowKeyToPartnerType = {
  [Flow.DirectoryListing]: PartnerType.DirectoryUser
};